<template>
  <div>
    <v-progress-linear indeterminate v-if="!finished"></v-progress-linear>
    <div class="text-right mb-2 noprint" v-if="finished">
      <TheButton
        text="Ver Pedido"
        icon="mdi-card-bulleted-outline"
        :color="state === 0 ? 'green' : 'blue-grey lighten-3'"
        @click="state = 0"
        css="mr-1"
      />
      <TheButton
        text="Histórico de Mensagens"
        icon="mdi-message-processing-outline"
        :color="state === 1 ? 'green' : 'blue-grey lighten-3'"
        @click="state = 1"
        :quantity="messages.length"
        css="mr-1"
      />
      <TheButton
        text="Ocorrências"
        icon="mdi-message-text-clock-outline"
        :color="state === 2 ? 'green' : 'blue-grey lighten-3'"
        @click="state = 2"
        css="mr-1"
        :quantity="problems.length"
      />
      <EditTracking
        :tracking="tracking"
        :sellerStatus="order.orderSellerStatus"
        :date="order.orderAuthorizedDate"
        :orderId="order.orderIdHubble"
      />
      <TheButton icon="mdi-printer" color="green" @click="print" />
    </div>
    <div v-if="finished" id="printArea">
      <OrderHeader :id="order.orderIdMarketplace" :idHubble="order.orderIdHubble" :idSeller="order.orderIdSeller" />
      <OrderDetails :order="order" v-if="state === 0" />
      <div v-if="state === 1">
        <TheOrderMessages :orderIdMarketplace="order.orderIdMarketplace" />
      </div>
      <div v-if="state === 2">
        <TheOrderMessages :orderIdMarketplace="order.orderIdMarketplace" :problem="true" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import TheButton from '@/components/TheButton'
import OrderDetails from '@/components/order/OrderDetails'
import OrderHeader from '@/components/order/OrderHeader'
import EditTracking from '@/components/order/EditTracking'
import TheOrderMessages from '@/components/TheOrderMessages'

import { mask } from 'vue-the-mask'
import { baseApiUrl, showError } from '@/global'
import { getColor, getStatusSeller, back, addBusinessDays } from '@/plugins/generic.js'

export default {
  name: 'Order',
  directives: { mask },
  components: {
    TheButton,
    OrderDetails,
    OrderHeader,
    EditTracking,
    TheOrderMessages,
  },
  data: () => ({
    order: {},
    tracking: {},
    messages: [],
    problems: [],
    interations: [],
    timeline: [],
    finished: false,
    state: 0,
    topic: {},
    messageDialog: false,
  }),
  methods: {
    getColor,
    getStatusSeller,
    addBusinessDays,
    loadOrder() {
      const id = this.$route.params.id
      const url = `${baseApiUrl}/order/${id}`
      axios
        .get(url)
        .then((res) => {
          this.order = res.data
          this.order.totals = [{ name: '', value: '' }]
          this.order.logisticTotal = 0
          // Tratativas da Logística
          this.order.logistic.forEach((element) => {
            this.order.logisticTotal += parseFloat(element.logisticPrice)
          })
          this.tracking.orderTracking = this.order.orderTracking
          this.tracking.orderTrackingUrl = this.order.orderTrackingUrl
          this.tracking.orderCarrier = this.order.orderCarrier
          this.tracking.orderSendDate = this.order.orderSendDate
          this.finished = true
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    formatStringData(data) {
      let dia = data.split('/')[0]
      let mes = data.split('/')[1]
      let ano = data.split('/')[2]
      return ano + '-' + ('0' + mes).slice(-2) + '-' + ('0' + dia).slice(-2) + 'T12:00:00-03:00'
    },
    async print() {
      const prtHtml = document.getElementById('printArea').innerHTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
  },
  created() {
    this.loadOrder()
  },
}
</script>
